export type Ilocations =
  | "pt_BR"
  | "es_CO"
  | "es_EC"
  | "es_MX"
  | "es_PA"
  | "es_PE"
  | "en_US"
  | "en_ZA";

const CURRENT_LANG =
  typeof localStorage?.getItem === "function"
    ? localStorage?.getItem("lang") || window.navigator.language
    : "es_MX";

/**
 * To get the language from the local storage, example "en_US"
 * @returns string
 */
export const getLanguage = (): string => CURRENT_LANG;

/**
 * To get just the language, example "en"
 * @returns string
 */
export const getLanguageName = (): string => CURRENT_LANG.substring(0, 2);

/**
 * To get just the location name, example: "US" || "us"
 * @param lowerCase optional boolean default false
 * @returns string
 */
export const getLocationName = (lowerCase?: boolean): string => {
  const locationName = CURRENT_LANG.substring(3, 5);
  return lowerCase ? locationName.toLowerCase() : locationName;
};

const mapLanguageLocale = {
  es: "es_MX",
  en: "en_US",
  pt: "pt_BR",
  id: "id_ID",
};

export const getDefaultLocale = (): string =>
  mapLanguageLocale[getLanguageName().toLowerCase()];

export const getSupportedLanguage = (lang: string): string => {
  lang = lang.toLowerCase();
  const langLocale = lang.substring(0, 2);

  if (langLocale === "en") {
    return "en_US";
  }

  if (langLocale === "es") {
    switch (lang) {
      case "es-co":
        return "es_CO";
      case "es-ec":
        return "es_EC";
      case "es-mx":
        return "es_MX";
      case "es-pe":
        return "es_PE";
      case "es-pa":
        return "es_PA";
      default:
        return "es_MX";
    }
  }

  if (langLocale === "pt") {
    return "pt_BR";
  }

  return "";
};

export const getLocaleFromCountry = (country: string): string => {
  switch (country) {
    case "BR":
      return "pt_BR";
    case "CO":
      return "es_CO";
    case "EC":
      return "es_EC";
    case "ID":
      return "id_ID";
    case "MX":
      return "es_MX";
    case "PA":
      return "es_PA";
    case "PE":
      return "es_PE";
    case "PH":
    case "US":
      return "en_US";
    case "ZA":
      return "en_ZA";
    default:
      return "es_MX";
  }
};

const DATE_FORMATS: { [key: string]: { format: string; separator: string } } = {
  es_MX: { format: "DD/MM/AAAA", separator: "/" },
  es_CO: { format: "DD/MM/AAAA", separator: "/" },
  es_PA: { format: "DD/MM/AAAA", separator: "/" },
  es_EC: { format: "DD/MM/AAAA", separator: "/" },
  es_PE: { format: "DD/MM/AAAA", separator: "/" },
  en_US: { format: "MM/DD/YYYY", separator: "/" },
  en_PH: { format: "MM/DD/YYYY", separator: "/" },
  en_ID: { format: "DD/MM/YYYY", separator: "/" },
  en_ZA: { format: "YYYY-MM-DD", separator: "-" },
  pt_BR: { format: "DD/MM/YYYY", separator: "/" },
  ceb_PH: { format: "MM/DD/YYYY", separator: "/" },
  tl_PH: { format: "MM/DD/YYYY", separator: "/" },
};

export const getCurrentLocaleInfo = (): {
  format: string;
  separator: string;
} => {
  const lang = getLanguage();
  return DATE_FORMATS[lang] || DATE_FORMATS["es_MX"];
};
